<template>
  <div>
    <v-toolbar dense class="primary mb-5" dark flat>
      Current Address
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-form ref="form" v-model="valid">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.add1"
            outlined
            :rules="rules"
            label="Street Address"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.city"
            outlined
            :rules="rules"
            label="City"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.state"
            :rules="rules"
            outlined
            label="State"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.zipcode"
            :rules="ziprules"
            outlined
            type="number"
            label="Zip Code"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-select
            v-model="form.type"
            :rules="rules"
            outlined
            :items="types"
            label="Rent / Own"
            required
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.payment"
            outlined
            :rules="rules"
            label="Monthly Payment"
            type="number"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="form.moveIn"
                :rules="rules"
                label="Move In Date"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="form.moveIn"
              :max="min"
              @input="menu = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.managerName"
            :rules="rules"
            outlined
            label="Landlord Name"
            ref="landload"
            required
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="form.managerPhone"
            outlined
            type="number"
            :rules="mobileRules"
            label="Landlord Phone"
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-form>
    <AddressHistory class="mb-5" v-model="addressHistory" />
    <v-btn @click="$emit('step', 2)" class="mr-5" color="primary">Back</v-btn>
    <v-btn color="success" @click="submit()">Continue</v-btn>
  </div>
</template>

<script>
import AddressHistory from "./AddressHistory";
export default {
  components: { AddressHistory },
  data() {
    return {
      form: {
        type: "",
        zipcode: "",
        add1: "",
        moveIn: "",
        city: "",
        state: "",
        payment: "",
        managerPhone: "",
        managerName: "",
      },
      valid: false,
      addressHistory: [],
      rules: [(v) => !!v || "Field is required"],
      emailRules: [
        (v) => !!v || "Field is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      types: ["Rent", "Own"],
      min: new Date().toISOString().substr(0, 10),
      menu: false,
      ziprules: [
        (v) => !!v || "Field is required",
        (v) => (!!v && v.length === 5) || "5 digit zip code required",
      ],
      mobileRules: [
        (v) => !!v || "Field is required",
        (v) => (!!v && v.length <= 10) || "Phone can't be more then 10 digit",
      ],
    };
  },
  methods: {
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.valid) return;
      let form = vm.$store.getters.form;
      form.address = vm.form;
      form.addressHistory = vm.addressHistory;
      vm.$store.commit("setForm", form);
      vm.$emit("step", 4);
    },
  },
  mounted() {
    const vm = this;
    let form = vm.$store.getters.form;
    vm.$store.commit("setForm", form);
    vm.$refs.landload.$el
      .querySelector("input")
      .setAttribute("autocomplete", "Landload");
    console.log(vm.$refs.landload.$el.querySelector("input"));
  },
};
</script>

<style></style>
